import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import IconShuffle from './svg/IconShuffle'; //'../svg/IMixRandom'

function ShuffleButton({ active, onClick }) {
  return (
    <div className={`align`} onClick={onClick} >
      <IconShuffle size={24} color={active ? Config.BRAND_PRIMARY : Config.TYPE_SECONDARY} className={`cf-icon-fill-v2`} />
    </div>
  )
}

ShuffleButton.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export default ShuffleButton;
